import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CountryRegion } from '@lx/shared/data-access/destination';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { SelectorField } from '@lx/quote-tool/lite/shared/ui/directives';
import { getCustomFormComponentControlValueAccessorProvider } from '@lx/quote-tool/lite/shared/utils';
import { DropdownSidePanelFieldComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { KeyboardFocusDirective } from '@lx/shared/ui/keyboard-focus';

@Component({
  standalone: true,
  selector: 'lx-region-country-field',
  templateUrl: './region-country-field.component.html',
  styleUrls: ['./region-country-field.component.scss'],
  imports: [NgIf, DropdownModule, InputTextModule, PaginatorModule, DropdownSidePanelFieldComponent, KeyboardFocusDirective],
  providers: [getCustomFormComponentControlValueAccessorProvider(RegionCountryFieldComponent)],
})
export class RegionCountryFieldComponent extends SelectorField<string> {
  @Input() regions: CountryRegion[] = [];
  @Input() textInputMode = false;
  @Input() placeholder = '';
  @Input() title: string;
}
